import { setMobileNavScroll, navDefaultVals } from 'helpers/utils';

const _nav = document.getElementsByClassName('js--nav')[0];
const _navMobile = document.getElementsByClassName('js--navMobile')[0];
const _mobileIcon = document.getElementsByClassName('js--mobileIcon')[0];

let resizeTimer = null;
let scrollTimer = null;

function setMaxHeightsOnMobileDropdowns() {
    const _mobileDropDownList = document.getElementsByClassName('js--dropdown-list')[0];
    const mobileLink = _mobileDropDownList.getElementsByClassName('nav__mobile-link')[0];
    const mobileLinkHeight = parseInt(getComputedStyle(mobileLink).height, 10);
    const mobileLinkMarginBottom = parseInt(getComputedStyle(mobileLink)['margin-bottom'], 10);
    const mobileLinkMarginTop = parseInt(getComputedStyle(mobileLink)['margin-top'], 10);

    const mobileLinkHeightTotal = mobileLinkHeight + mobileLinkMarginBottom + mobileLinkMarginTop;
    const dropdownLists = document.getElementsByClassName('js--dropdown-list');

    for (let i = dropdownLists.length - 1; i >= 0; i -= 1) {
        const _this = dropdownLists[i];
        const listCount = _this.querySelectorAll('li').length;

        _this.setAttribute('data-max-height', `${listCount * mobileLinkHeightTotal}px`);
    }
}

function setMobileRemoveBtn() {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
        const removeBtnWidth =
            _mobileIcon.offsetWidth +
            parseInt(
                getComputedStyle(_navMobile.getElementsByClassName('nav__mobile-links')[0])[
                    'padding-right'
                ],
                10,
            );
        const navWrapperWidth = Math.ceil(
            (window.innerWidth - document.getElementsByClassName('nav__wrapper')[0].offsetWidth) /
                2,
        );
        const mobileWidth = _navMobile.offsetWidth - removeBtnWidth - navWrapperWidth;

        _mobileIcon.setAttribute('data-transform', `${mobileWidth}px`);
    }, 250);
}

function dropdown(el) {
    Array.from(document.getElementsByClassName('nav__item--active')).forEach(
        (el) => el !== null && el.classList.remove('nav__item--active'),
    );

    el.closest('.nav__item').classList.add('nav__item--active');

    Array.from(el.getElementsByClassName('nav__submenu')).forEach(
        (el) => el !== null && el.classList.add('nav__submenu--active'),
    );
}

function dropdownExit() {
    Array.from(document.getElementsByClassName('nav__item--active')).forEach((el) =>
        el.classList.remove('nav__item--active'),
    );

    Array.from(document.getElementsByClassName('nav__submenu--active')).forEach((el) =>
        el.classList.remove('nav__submenu--active'),
    );
}

function toggleMobile() {
    const _navOverlay = document.getElementsByClassName('js--navOverlay')[0];

    _navMobile.classList.toggle('nav__mobile--close');
    _navOverlay.classList.toggle('nav__mobile-overlay--hide');

    Array.from(document.querySelectorAll('html, body')).forEach((el) =>
        el.classList.toggle('nav__mobile--open'),
    );

    if (!document.body.classList.contains('nav__mobile--open')) {
        toggleMobileDropdown(null, true);
    }
}

function throttleOrDie() {
    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
        checkNavbar();
    }, 10);
}

function checkNavbar() {
    if (window.pageYOffset >= 1) {
        return _nav.classList.add('nav-scroll');
    }

    _nav.classList.remove('nav-scroll');
}

function removeStylesAttr(list) {
    for (let i = list.length - 1; i >= 0; i -= 1) {
        list[i]
            .closest('.nav__mobile-li')
            .getElementsByClassName('js--dropdown-list')[0]
            .setAttribute('style', null);
    }

    Array.from(document.getElementsByClassName('js--mobile-dropdown')).forEach((el) =>
        el.classList.remove('nav__mobile-link--active'),
    );

    Array.from(document.getElementsByClassName('js--dropdown-list')).forEach((el) =>
        el.classList.remove('nav__mobile-dropdown--active'),
    );
}

function toggleMobileDropdown(el, close) {
    let delay = 0;
    let activeDropdowns = Array.from(document.getElementsByClassName('nav__mobile-link--active'));

    if (close) {
        return removeStylesAttr(activeDropdowns);
    }

    const _dropdownList = el
        .closest('.nav__mobile-li')
        .getElementsByClassName('js--dropdown-list')[0];
    const maxHeight = _dropdownList.getAttribute('data-max-height');

    if (activeDropdowns.length === 1 && el === activeDropdowns[0]) {
        activeDropdowns = [];
    }

    if (activeDropdowns.length) {
        delay = 210;

        removeStylesAttr(activeDropdowns);
    }

    setTimeout(() => {
        if (el.classList.contains('nav__mobile-link--active')) {
            _dropdownList.setAttribute('style', null);
        } else {
            _dropdownList.style['max-height'] = maxHeight;
        }

        el.classList.toggle('nav__mobile-link--active');
        _dropdownList.classList.toggle('nav__mobile-dropdown--active');
    }, delay);
}

function init() {
    const _mobileToggles = Array.from(
        document.querySelectorAll('.js--navOverlay, .js--mobileIcon'),
    );
    const _dropdown = document.getElementsByClassName('js--dropdown');
    const _mobileDropdownLink = document.getElementsByClassName('js--mobile-dropdown');

    setMobileNavScroll(_navMobile);
    setMaxHeightsOnMobileDropdowns();
    setMobileRemoveBtn();

    window.addEventListener('resize', (e) => {
        e.preventDefault();
        setMobileRemoveBtn();
    });

    _mobileToggles.forEach((k) => k.addEventListener('click', () => toggleMobile()));

    Array.from(_dropdown).forEach((k) => {
        ['mouseenter', 'click'].map((event) => k.addEventListener(event, () => dropdown(k)));

        k.addEventListener('mouseleave', () => dropdownExit());
    });

    window.addEventListener('scroll', () => throttleOrDie());

    Array.from(_mobileDropdownLink).forEach((k) =>
        k.addEventListener('click', (e) => {
            e.preventDefault();
            toggleMobileDropdown(k);
        }),
    );
    navDefaultVals();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/navigation.js